var map = {
	"./tutorial_saba_1.png": 72059,
	"./tutorial_saba_2.png": 72857,
	"./tutorial_saba_3.png": 48902,
	"./tutorial_saba_4.png": 40936,
	"./tutorial_saba_5.png": 50495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42637;